import React from 'react';

import { Button, Col, Flex, Row, Tooltip, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

type DisableComponents = {
  tooltip: boolean;
  tooltipTitle?: string;
  button: boolean;
};

type Props = {
  onSubmit: () => void;
  onSubmitDraft: () => void;
  disabledDraft: DisableComponents;
  disabled: DisableComponents;
  isService: boolean;
};

const DraftButtons = ({ onSubmit, onSubmitDraft, disabledDraft, disabled, isService }: Props) => {
  const text = isService
    ? 'Clicando em pronto para vender seu serviço será enviado para moderação e o link de vendas ficará habilitado.'
    : 'Clicando em pronto para vender seu produto será enviado para moderação e o link de vendas ficará habilitado.';
  return (
    <Row justify='end'>
      <Col span={24} key='helper-text' className='mb-3'>
        <Row justify='end'>
          <Flex align='center' justify='center' gap='small'>
            <Icon.Info  />
            <Typography.Text strong>{text}</Typography.Text>
          </Flex>
        </Row>
      </Col>
      <Col span={24} key='draft-buttons'>
        <Row justify='end' gutter={[16, 16]}>
          <Col>
            <Tooltip
              placement='top'
              title={
                disabledDraft.tooltip
                  ? ''
                  : (disabledDraft.tooltipTitle ?? 'Preencha o título para poder salvar como rascunho')
              }
            >
              <div>
                <Button
                  id='new-product-draft-button'
                  onClick={() => onSubmitDraft()}
                  icon={<Icon.File  />}
                  disabled={disabledDraft.button}
                >
                  Salvar como rascunho
                </Button>
              </div>
            </Tooltip>
          </Col>
          <Col>
            <Tooltip placement='top' title={disabled.tooltip ? '' : 'Preencha os campos obrigatórios para salvar'}>
              <div>
                <Button
                  id='new-product-save-button'
                  type='primary'
                  onClick={() => onSubmit()}
                  icon={<Icon.Zap  />}
                  disabled={disabled.button}
                >
                  Pronto para vender
                </Button>
              </div>
            </Tooltip>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DraftButtons;
